import * as React from 'react';
import ContentSetting, { Sizes } from '@99designs/apps/spa/pages/create/components/ContentSetting';
import DesignerResults from '@99designs/apps/spa/pages/create/components/DesignerResults';
import { InviteDesignersPageComponent } from '@99designs/apps/spa/pages/create/components/InviteDesignersPage.generated';
import { trackViewedBriefEvent } from '@99designs/apps/spa/pages/create/events';
import { Paragraph } from '@99designs/emu';
import { LoadableElement } from '@99designs/frontend-components/components/LoadableElement';

export interface Props {
    brief: {
        id: string;
        designers: { id: string; displayName: string }[];
        category?: {
            key: string;
            title: string;
        } | null;
    };
    children?: React.ReactNode;
    description?: React.ReactNode;
}

export default function InviteDesigners(props: Props) {
    const { brief } = props;

    React.useEffect(() => {
        trackViewedBriefEvent({
            id: props.brief.id,
            page: 'InviteDesigners',
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InviteDesignersPageComponent variables={{ id: brief.id }} fetchPolicy="network-only">
            {({ loading, data, error }) => {
                if (loading) {
                    return <LoadableElement isLoading={true} variations={['relative ']} />;
                }

                if (error) {
                    throw error;
                }

                if (!data || !data.brief) {
                    return <>{__('Not Found')}</>;
                }

                return (
                    <div data-testid="invite-designers">
                        <ContentSetting size={Sizes.Default}>
                            <Paragraph as="div" color="grey700">
                                {props.description}
                            </Paragraph>
                        </ContentSetting>
                        <ContentSetting size={Sizes.Full}>
                            {props.children}
                            <DesignerResults brief={data.brief} />
                        </ContentSetting>
                    </div>
                );
            }}
        </InviteDesignersPageComponent>
    );
}
